var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavOffersUser = function SvgNavOffersUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nav_offers_user_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nav_offers_user_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_offers_user_svg__user"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "nav_offers_user_svg__st0",
    cx: 24.1,
    cy: 19.4,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_user_svg__st0",
    d: "M18.6 30.3c0-3.4 2.4-6.2 5.4-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_user_svg__st0",
    d: "M29.2 30.3c0-3.4-2.4-6.2-5.3-6.2"
  }))));
};
export default SvgNavOffersUser;